module.exports = __webpack_public_path__ + "assets/images/skincolor-01.ec2939be4696224b2d2bc4264816eab7.svg";